



import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom"; // <-- ADDED for reading :id from URL
import Button from "../Button";
import { supabase, fetchInChunks } from "../../supabaseClient";
import TilesList from "../MovieTile/TilesList";
import { VscCheckAll } from "react-icons/vsc";
import Swal from "sweetalert2";
import { PutObjectCommand } from "@aws-sdk/client-s3";
import { minioClient } from "../../minioClient";
import { RxCross2 } from "react-icons/rx";
import Pagination from "../Pagination";
import { getCurrentUser } from "../../Components/currentUser";


function MovieRowForm({
  setShowModal,
  fetchPagesWithRows,
  // editPage,
  editPage: editPageProp,
  searchPage,
}) {
  const { id } = useParams(); // <-- ADDED for detecting edit mode from URL
  const [pageName, setPageName] = useState("");
  const [rowItems, setRowItems] = useState([]);
  const [tilesData, setTilesData] = useState([]);
  const [iconFile, setIconFile] = useState(null);
  const [iconPreview, setIconPreview] = useState(null);
  const [selectedRows, setselectedRows] = useState([]);
  const [draggedRowIndex, setDraggedRowIndex] = useState(null);
  const [editPage, setEditPage] = useState(editPageProp || null); // <-- store fetched page
  const navigate = useNavigate();

  const minioBaseUrl = "https://images.do.cloudwalker.tv/images/";

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const pageSize = 16; // 9 items per page
  const [searchTerm, setSearchTerm] = useState("");

  const fetchRows = async (pageNumber = 1, search = "") => {
    try {
      const from = (pageNumber - 1) * pageSize;
      const to = from + pageSize - 1;

      let query = supabase
        .from("row_data")
        .select("*", { count: "exact" })
        .order("updated_at", { ascending: false })
        .range(from, to);

      // Add search condition if search term exists
      if (search.trim() !== "") {
        query = query.ilike("row_header", `%${search}%`);
      }

      const { data, error, count } = await query;

      if (error) throw error;

      setRowItems(data || []);
      setTotalPages(Math.ceil((count || 0) / pageSize));
    } catch (error) {
      console.error("Error fetching movie data:", error);
    }
  };

  useEffect(() => {
    fetchRows(page, searchTerm);
  }, [page, searchTerm]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // <-- ADDED: fetch page data if :id exists and editPage is not passed as prop
  useEffect(() => {
    const fetchPageData = async () => {
      if (!id) return;
      const { data, error } = await supabase
        .from("pages")
        .select("*")
        .eq("id", id)
        .single();
      if (error) {
        console.error("Error fetching page for edit:", error);
        return;
      }
      setEditPage(data);
    };
    fetchPageData();
  }, [id]);

  useEffect(() => {
    const fetchTilesData = async () => {
      if (rowItems.length === 0) return;
      const tileIds = rowItems.flatMap((row) =>
        row.row_items.map((item) => item.tid)
      );

      const { data, error } = await fetchInChunks("tiles", "*", "tid", tileIds);

      if (error) {
        console.error("Error fetching tile data:", error);
      } else {
        setTilesData(data);
      }
    };

    fetchTilesData();
  }, [rowItems]);

  useEffect(() => {
    if (!editPage) {
      setPageName("");
      setselectedRows([]);
      setIconPreview(null);
      return; // ← Skip fetching
    }

    setPageName(editPage.page_name);
    setselectedRows(editPage.rows);

    if (editPage.icon) {
      setIconPreview(editPage.icon);
    }

    const fetchSelectedRows = async () => {
      try {
        const { data: rowData, error } = await supabase
          .from("row_data")
          .select("*")
          .in(
            "id",
            editPage.rows.map((r) => r)
          );
        if (error) throw error;

        const orderedRows = editPage.rows
          .map((id) => rowData.find((row) => row.id === id))
          .filter(Boolean);
        setselectedRows(orderedRows);

      } catch (error) {
        console.error("Error fetching selected tiles:", error);
      }
    };

    fetchSelectedRows();
  }, [editPage]);

  const toggleTileSelection = (tile) => {
    setselectedRows((prevselectedRows) =>
      prevselectedRows.some((t) => t.id === tile.id)
        ? prevselectedRows.filter((t) => t.id !== tile.id)
        : [...prevselectedRows, tile]
    );
  };
  const toggleAllTiles = () => {
    if (selectedRows.length === rowItems.length) {
      setselectedRows([]);
    } else {
      setselectedRows(rowItems);
    }
  };

  const handlePageSubmit = async (e) => {
    e.preventDefault();

    if (pageName === "" || selectedRows.length === 0) {
      alert("Please enter a page name and select rows.");
      return;
    }

    let iconUrl = "";

    try {
      if (iconFile instanceof File) {
        const BUCKET_NAME = "images";
        const basePath = "page-icons";
        const fileName = `${basePath}/${Date.now()}-${iconFile.name}`;
        const buffer = await iconFile.arrayBuffer();

        const uploadCommand = new PutObjectCommand({
          Bucket: BUCKET_NAME,
          Key: fileName,
          Body: buffer,
          ContentType: iconFile.type,
        });

        await minioClient.send(uploadCommand);
        iconUrl = `https://images.do.cloudwalker.tv/${BUCKET_NAME}/${fileName}`;
      }

      if (editPage) {
        const { error: updateError } =
        
          await supabase
            .from("pages")
            .update({
              page_name: pageName,
              rows: selectedRows.map((row) => row.id),
              icon: iconUrl || editPage.icon,
              updated_by: getCurrentUser(),              // ✅ who edited
              updated_at: new Date().toISOString(),      // ✅ when edited
            })
            .eq("id", editPage.id);


        if (updateError) throw updateError;

        // Swal.fire({ text: "Page updated successfully", icon: "success" });
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Page updated successfully!", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
      } else {
        const { error: insertError } = await supabase.from("pages").insert([
          {
            page_name: pageName,
            rows: selectedRows.map((row) => row.id),
            icon: iconUrl,
          },
        ]);

        if (insertError) throw insertError;

        // Swal.fire({ text: "Page added successfully", icon: "success" });
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Page added successfully",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "shadow-lg rounded-md p-3 bg-white",
          },
        });
      }
      navigate("/"); // or wherever you want to redirect

      // setShowModal(false);
      // fetchPagesWithRows(1, searchPage);
    } catch (err) {
      console.error("Error submitting page:", err.message);
      // Swal.fire({ text: "Something went wrong", icon: "error" });
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Something went wrong",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "shadow-lg rounded-md p-3 bg-white",
        },
      });
    }
  };

  return (
    <div className="h-screen p-4 bg-gray-50">
      {/* Back button */}
      <div className="mb-4">
        <Button
          variant="secondary"
          className="flex items-center gap-2 px-4 py-2"
          onClick={() => window.history.back()}
        >
          <span className="text-lg">←</span>
          Back
        </Button>
      </div>

      {/* Scrollable content */}
      <form
        onSubmit={handlePageSubmit}
        className="space-y-4 border border-slate-300 bg-gray-100 p-4 mx-auto rounded-md h-[calc(100vh-9rem)] overflow-auto"
      >
        {/* Page name */}
        <div>
          <input
            type="text"
            value={pageName}
            onChange={(e) => setPageName(e.target.value)}
            className="mt-1 block w-full py-2 px-4 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Enter Page Name"
            required
          />
        </div>

        {/* Icon */}
        <div className="flex flex-col sm:flex-row items-center gap-4 col-span-1 sm:col-span-2 p-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700">
              Icon
            </label>
            <input
              type="file"
              name="page_icon"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  setIconFile(file);
                  setIconPreview(URL.createObjectURL(file));
                }
              }}
              className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:bg-indigo-300 file:text-black hover:file:bg-indigo-400"
            />
          </div>
          {iconPreview && (
            <div className="w-full sm:w-3/4 md:w-1/2 flex justify-center items-center h-40">
              <img
                src={
                  iconPreview instanceof File
                    ? URL.createObjectURL(iconPreview)
                    : iconPreview
                      ? iconPreview
                      : `${minioBaseUrl}${iconPreview}`
                }
                alt="Icon Preview"
                className="rounded-md h-full max-h-full object-cover"
              />
            </div>
          )}
        </div>


        {/* Check/Uncheck */}
        <div className="text-end">
          <div className="flex justify-between">
            <Button
              variant={
                selectedRows.length === rowItems.length ? "danger" : "success"
              }
              onClick={toggleAllTiles}
              className="px-4 py-1 text-sm flex items-center gap-3"
            >
              <VscCheckAll />
              {selectedRows.length === rowItems.length
                ? "Uncheck All"
                : "Check All"}
            </Button>
            {/* Search bar (only when no icon selected) */}
            {!iconPreview && (
              <div className="mb-4">


                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setPage(1); // 👈 Reset to first page when searching
                  }}
                  placeholder="Search rows..."
                  className="w-full px-4 py-2 border rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            )}
          </div>

          {/* Selected rows preview */}
          {selectedRows.length > 0 && (
            <div className="w-full mt-6 bg-white border border-gray-300 rounded-lg p-4">
              <h3 className="text-sm font-semibold mb-3 text-gray-700">
                {/* Rows ({selectedRows.length}) */}
              </h3>
              <div className="flex flex-wrap gap-3 max-h-48 overflow-y-auto">
                {selectedRows.map((row, index) => (
                  <div
                    key={row.id}
                    draggable
                    onDragStart={() => setDraggedRowIndex(index)}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={() => {
                      if (draggedRowIndex === null || draggedRowIndex === index)
                        return;

                      const reordered = [...selectedRows];
                      const [movedItem] = reordered.splice(draggedRowIndex, 1);
                      reordered.splice(index, 0, movedItem);
                      setselectedRows(reordered);
                      setDraggedRowIndex(null);
                    }}
                    className="flex items-center gap-2 px-3 py-2 border rounded-md bg-gray-100 hover:bg-gray-200 cursor-move"
                  >
                    <span className="font-medium text-sm">
                      {row.row_header}
                    </span>
                    <button
                      type="button"
                      onClick={() =>
                        setselectedRows((prev) =>
                          prev.filter((r) => r.id !== row.id)
                        )
                      }
                      className="text-red-600 hover:text-red-800 text-sm"
                      title="Remove"
                    >
                      <RxCross2 />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* Row items grid */}
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {rowItems.map((item) => {
              const isSelected = selectedRows.some((t) => t.id === item.id);
              return (
                // <div
                //   key={item.id}
                //   className={`hover:shadow-md relative p-4 border rounded-lg shadow-md ${
                //     isSelected ? "border-green-600" : "border-gray-200"
                //   }`}
                //   onClick={() => toggleTileSelection(item)}
                // >

                <div
                  key={item.id}
                  className={`hover:shadow-md cursor-grab relative p-4 border rounded-lg shadow-md ${isSelected ? "border-green-600" : "border-gray-200"
                    }`}
                  onClick={() => toggleTileSelection(item)}
                >

                  {isSelected && (
                    <div className="absolute top-2 right-2 bg-green-600 text-white text-xs w-6 h-6 flex items-center justify-center rounded-full">
                      {selectedRows.findIndex((t) => t.id === item.id) + 1}
                    </div>
                  )}

                  {/* <div className="flex justify-between"> */}
                  <div className="mb-2 text-sm font-bold text-gray-900 line-clamp-2 flex justify-start">
                    {item.row_header}
                  </div>
                  <TilesList
                    singleRow={item}
                    setRows={setRowItems}
                    tilesData={tilesData}
                    rows={rowItems}
                  />
                  {/* </div> */}

                </div>
              );
            })}
          </div>
        </div>

        {/* Save button */}
        <div className="sticky bottom-0 z-20 -mx-4 px-4 py-3 flex">
          <Button
            variant="success"
            type="submit"
            className="px-5 py-1 mx-auto text-sm flex items-center gap-3"
          >
            Save
          </Button>
        </div>
      </form>

      {/* Pagination outside scrollable content */}
      {/* <div className="mt-4 flex justify-end"> */}
      <Pagination
        currentPage={page}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      {/* </div> */}
    </div>
  );
}

export default MovieRowForm;


